import { ChartType, getHiddenTableFields, isCartesianChartConfig, } from '../types/savedCharts';
const getTablePivotConfig = (tableChartConfig, pivotConfig, tableConfig) => pivotConfig && pivotConfig.columns.length > 0
    ? {
        pivotDimensions: pivotConfig.columns,
        metricsAsRows: tableChartConfig.config?.metricsAsRows ?? false,
        hiddenMetricFieldIds: getHiddenTableFields(tableChartConfig),
        columnOrder: tableConfig.columnOrder,
        rowTotals: tableChartConfig.config?.showRowCalculation ?? false,
        columnTotals: tableChartConfig.config?.showColumnCalculation ?? false,
    }
    : undefined;
const getCartesianPivotConfig = (chartConfig, pivotConfig) => {
    if (!pivotConfig || pivotConfig.columns.length === 0) {
        return undefined;
    }
    const result = {
        pivotDimensions: pivotConfig.columns,
        metricsAsRows: false,
    };
    // When sort-only metrics are injected into valuesColumns (PROD-6906),
    // they would bleed into exports/UI. Set visibleMetricFieldIds to the
    // chart's yField so only displayed metrics appear in pivot output.
    if (isCartesianChartConfig(chartConfig.config)) {
        const { yField } = chartConfig.config.layout;
        if (yField && yField.length > 0) {
            result.visibleMetricFieldIds = yField;
        }
    }
    return result;
};
export const getPivotConfig = (savedChart) => {
    switch (savedChart.chartConfig.type) {
        case ChartType.TABLE:
            return getTablePivotConfig(savedChart.chartConfig, savedChart.pivotConfig, savedChart.tableConfig);
        case ChartType.CARTESIAN:
            return getCartesianPivotConfig(savedChart.chartConfig, savedChart.pivotConfig);
        default:
            return undefined;
    }
};
//# sourceMappingURL=pivotConfig.js.map